export const posts = [
  {
    id: 1,
    userName: "Diêgo",
    postTitle: "Post test from the Mock",
    postDescription:
      "img link: https://imgur.com/e7Qa2R Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus, excepturi temporibus eum expedita adipisci sit sequi! Aliquid quas error cum ullam iusto quisquam a illum, aperiam rerum perspiciatis sapiente nemo!",
    postedTime: 8,
    postHashTags: ["#REACT", "#JS", "#POST"],
    imgLink: "https://i.imgur.com/e7Qa2RP.jpeg",
    userImgLink: "https://avatars.githubusercontent.com/u/101150281?v=4",
  },

  {
    id: 2,
    userName: "RandomUser",
    postTitle: "Photograph of the moon by the last human to visit it",
    postDescription:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus, excepturi temporibus eum expedita adipisci sit sequi! Aliquid quas error cum ullam iusto quisquam a illum, aperiam rerum perspiciatis sapiente nemo!",
    postedTime: 8,
    postHashTags: ["#Inspiration"],
    imgLink:
      "http://tothemoon.ser.asu.edu/data_a70/AS17/extra/AS17-137-20956.small.png",
    userImgLink: "https://avatars.githubusercontent.com/u/101150281?v=4",
  },

  {
    id: 3,
    userName: "User2",
    postTitle: "NATURE BY DACE",
    postDescription: "Imgur post link: https://imgur.com/t/inspiring/ogIHl0P ",
    postedTime: 8,
    postHashTags: ["#REACT", "#JS", "#POST"],
    imgLink: "https://i.imgur.com/XmYSyXh.jpeg",
    userImgLink: "https://avatars.githubusercontent.com/u/101150281?v=4",
  },
];
